module.exports = __webpack_public_path__ + "static/media/online-tutoring-student.2d864647.jpg";